import styled from '@emotion/styled'
import { Button, Divider, Layout, Menu, Row, Space, Typography } from 'antd'
import Sider from 'antd/es/layout/Sider'
import MenuFolded from 'Components/Icons/MenuFolded'

interface ICollapsible {
  collapsed?: string
}

export const PageLayout = styled(Layout)`
  height: 100vh !important;
`

export const ContentLayout = styled(PageLayout)<ICollapsible>`
  max-width: ${({ collapsed }) =>
    collapsed === 'true' ? 'calc(100vw - 50px)' : 'calc(100vw - 250px)'};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: transparent;
`

export const PageMenu = styled(Menu)<ICollapsible>`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${({ theme }) => (theme === 'dark' ? 'var(--blue-500)' : 'inherit')};
  padding: ${({ collapsed }) => (collapsed === 'true' ? '8px 4px' : '8px')};
  border-inline-end: unset !important;
`

export const MenuDivider = styled(Divider)`
  margin: 0 0 0.25rem 0 !important;
`
export const ThemedRow = styled(Row)`
  color: ${({ theme }) => (theme === 'dark' ? 'var(--secondary-50)' : 'var(--neutral-400)')};
`
export const MenuRow = styled(ThemedRow)`
  margin-top: auto;
  flex-direction: column;
`

export const UserName = styled(Typography.Text)`
  color: ${({ theme }) => (theme === 'dark' ? 'var(--secondary-50)' : 'var(--neutral-400)')};
  align-items: center;
  max-width: 25ch !important;
  font-size: 0.7rem;
  padding: 4px 8px;
`

export const BrandText = styled(UserName)`
  opacity: 0.7;
`

export const LogoContainer = styled.div<ICollapsible>`
  display: flex;
  flex-direction: ${({ collapsed }) => (collapsed === 'true' ? 'column-reverse' : 'row')};
  align-items: center;
  justify-content: ${({ collapsed }) => (collapsed === 'true' ? 'space-around' : 'space-between')};
  height: 70px;
  padding: 0 8px;
  cursor: default;
  user-select: none;
  background-color: ${({ theme }) => (theme === 'dark' ? 'var(--blue-500)' : 'transparent')};
`

export const UserRow = styled(ThemedRow)`
  justify-content: space-between;
  align-items: middle;
  flex-direction: row;
  padding: 2px 8px;
  height: 40px;
  background-color: ${({ theme }) => (theme === 'dark' ? 'var(--blue-500)' : 'transparent')};
`

export const LogoSpace = styled(Space)`
  background-color: ${({ theme }) => (theme === 'dark' ? 'var(--blue-500)' : 'inherit')};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  height: 40px;
  width: 100%;
`

export const MenuSider = styled(Sider)`
  display: flex;
  flex-direction: column;
  background-color: var(--secondary-50) !important;
  border-inline-end: 1px solid rgba(5, 5, 5, 0.06);
`

export const UnfoldOutlined = styled(MenuFolded)`
  color: ${({ theme }) => (theme === 'dark' ? 'var(--primary-100)' : 'var(--secondary-400)')};
  transform: rotate(180deg);
`

export const FoldOutlined = styled(MenuFolded)`
  color: ${({ theme }) => (theme === 'dark' ? 'var(--primary-100)' : 'var(--neutral-300)')};
`

export const LogoutButton = styled(Button)`
  color: ${({ theme }) => (theme === 'dark' ? 'var(--secondary-50)' : 'var(--neutral-400)')};
  svg {
    height: 0.75em;
    width: 0.75em;
    margin-bottom: 1px;
  }
`

export const Em = styled.em({
  fontSize: '10px',
  color: 'var(--neutral-300)',
})

export const HeaderRow = styled(ThemedRow)`
  position: sticky;
  z-index: 1;
  width: 100%;
  background: tranparent;
`

// export const PageContent = styled(Layout.Content)`
//   padding: 20px;
//   overflow-y: auto;
//   border-radius: 1rem 0 0 0;
//   background-color: white;
//   border-width: 1px, 0px, 0px, 1px;
//   border-style: solid;
//   border-color: rgba(240, 240, 240, 1);
//   z-index: 100;
// `
export const PageContent = styled(Layout.Content)`
  padding: 20px;
  overflow-y: auto;
  border-radius: 1rem 0 0 0;
  background-color: white;
  border-width: 1px, 0px, 0px, 1px;
  border-style: solid;
  border-color: rgba(240, 240, 240, 1);
  z-index: 100;
`

export const PageTitle = styled(Typography.Title)`
  color: var(--neutral-400);
`
export const HomeRow = styled(ThemedRow)`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
`

export const LayoutRow = styled(Row)`
  position: sticky;
  z-index: 1;
  width: 100%;
  & .ant-page-header {
    width: 100%;
    padding-bottom: 0px;
  }
`
export const Title = styled.span`
  white-space: nowrap;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => (theme === 'dark' ? 'var(--secondary-50)' : 'var(--blue-600)')};
  font-size: 0.875rem;
  font-weight: 500;
  margin-left: 0.5rem;
`

export const MenuTitle = ({ theme, children }: { theme: string; children: string }) => {
  return (
    <Title theme={theme} title={children}>
      {children}
    </Title>
  )
}
